module.exports = __webpack_public_path__ + "static/img/LeiLiHeadShot_old.46986e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/LeiLiHeadShot_old.png
// module id = 1564
// module chunks = 5